import PropTypes from "prop-types";
import React, { Component } from "react";
import SVGInline from "react-svg-inline";
import { MorphReplace } from "react-svg-morph";

/* eslint import/no-webpack-loader-syntax: off */
import logoObersoundSVG from "!raw-loader!../images/logos/logo-obersound.svg";
import ProfileBoldIcon from "./icons/ProfileBoldIcon";
import CloseIcon from "./icons/CloseIconSVG";
import BarsIcon from "./icons/BarsIconSVG";
import LocalizedLink from "../containers/LocalizedLink";

class Header extends Component {
  render() {
    const {
      authLoggedIn,
      leftSidebarOpen,
      handleBarsIconClick,
      handleUserIconClick,
      t,
    } = this.props;

    return (
      <div className="header">
        <div className="header">
          <div className="header__wrapper">
            <div className="header__menu">
              <div className="panel-header__icon" onClick={handleBarsIconClick}>
                <MorphReplace
                  rotation="none"
                  duration={200}
                  viewBox="0 0 24 24"
                  height={24}
                  width={24}
                  strokeWidth={2}
                >
                  {leftSidebarOpen ? (
                    <CloseIcon key="checked" />
                  ) : (
                    <BarsIcon key="checkbox" />
                  )}
                </MorphReplace>
              </div>
            </div>

            <div className="header__logo">
              <LocalizedLink className="header__logo link black mt1 center" to="/">
                <SVGInline height={"54px"} svg={logoObersoundSVG} />
              </LocalizedLink>
            </div>

            <div className="header__right">
              {authLoggedIn && (
                <div className="header__link">
                  <LocalizedLink to="/account" className="link black">
                    <i className="header__models i-models" />
                    {t("mymodels")}
                  </LocalizedLink>
                </div>
              )}

              <div className="header__profile" onClick={handleUserIconClick}>
                <ProfileBoldIcon />
              </div>
            <div className="header__lang">
                <div className="header__lang-container">
                <LocalizedLink className= {this.props.lng==='fr' ? 'header__lang-item header__lang-item--active' : 'header__lang-item'} to="/fr" from="header">
                  FR
                </LocalizedLink>
                <div className="header__lang-item--separator">&bull;</div>
                <LocalizedLink className={this.props.lng==='en' ? 'header__lang-item header__lang-item--active' : 'header__lang-item'} to="/en" from="header">
                  EN
                </LocalizedLink>
                <div className="header__lang-item--separator">&bull;</div>
                <LocalizedLink className={this.props.lng==='es' ? 'header__lang-item header__lang-item--active' : 'header__lang-item'} to="/es" from="header">
                  ES
                </LocalizedLink>
                {/*window.location.pathname*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  hidden: PropTypes.bool,
  leftSidebarOpen: PropTypes.bool,
  handleBarsIconClick: PropTypes.func,
  handleUserIconClick: PropTypes.func
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js